import React, { useEffect, useState } from 'react'
import RegisterIdentifyViewV2 from './RegisterIdentifyViewV2';
import PublicPage from '../PublicPage';
import { paths } from '../../config/router.config';
import wsclients from '../../services/wsclients';
import { useTranslation } from 'react-i18next';
import CustomAlert from '../../components/CustomAlert';
import CustomLoading from '../../components/CustomLoading';
import { useLocation } from 'react-router-dom';
import { useHistory } from 'react-router-dom';

export default function RegisterIdentifyControllerV2(props) {
    const { t } = useTranslation();
    const location = useLocation();
    const history = useHistory();
    const [contactId, setcontactId] = useState(null);
    const [accessToken, setaccessToken] = useState(null);
    const [showLoading, onShowLoading] = useState(false);
    const [message, setMessage] = useState({});

    useEffect(() => {
        if (location.state) {
            if (location.state.contactId) setcontactId(location.state.contactId);
            if(location.state.access_token) setaccessToken(location.state.access_token)
        }
    }, [location.state]);

    const onShowMessage = (message) => {
        onShowLoading(false)
        setMessage(message)
    }

    const handleVerification = async (values) => {
        onShowLoading(true);
        if (values && values.email)
            try {
                var result = await wsclients.contacts.identityVerification({
                    contactId: contactId, 
                    email: values.email, 
                    password: values.password,
                    access_token: accessToken
                });
                console.log("identityVerification result:", result);
                if (result.code == 'OK') {
                    history.push(paths.login)
                } else if (result.code == 'UNCLASSIFIED_ERROR') {
                    onShowMessage({ show: true, content:t('The account already exists. Please contact customer support.') });
                } else if (result.code == 'TOO_MANY_REQUESTS') {
                    onShowMessage({ show: true, content: t('Too Many Requests') });
                } else {
                    onShowMessage(true, t('Error'));
                }
            } catch (error) {
                console.log("on contacts Otp exception:", error);
                onShowMessage({ show: true, content: t('EXCEPTION_PROCESS') });
            }
        onShowLoading(false);
    }
    const handleOkButton = () => {
        history.push(paths.register_existing);
    };

    return (
        <>
            <PublicPage
                rightComponent={
                    <RegisterIdentifyViewV2
                        handleVerification={handleVerification}
                    />
                }
            />
            {message.show && <CustomAlert
                open={message.show}
                message={message.content}
                showButtonClose={false}
                onClose={() => onShowMessage({})}
                isConfirm={true}
                confirmAction={{ okAction: handleOkButton }} 
            />}
            {showLoading && <CustomLoading open={showLoading} />}
        </>
    );
}